import { CommonModule } from '@angular/common';
import { Component, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FieldArrayType, FormlyModule } from '@ngx-formly/core';
import { ConfirmationService } from 'app/services/confirmation/confirmation.service';

@Component({
    selector: 'formly-repeat-section',
    template: `
        <div
            *ngFor="let field of field.fieldGroup; let i = index"
            class="border border-gray-200 rounded-xl p-2 mb-2 relative">
            <formly-field [field]="field"></formly-field>
            <button
                type="button"
                mat-icon-button
                color="warn"
                class="absolute top-0 right-0"
                (click)="remove(i)">
                <mat-icon>delete</mat-icon>
            </button>
        </div>
        <button type="button" mat-raised-button color="primary" (click)="add()" class="mt-2">
            <mat-icon class="mr-2">add</mat-icon> Add Row
        </button>
    `,
    imports: [CommonModule, MatIconModule, MatButtonModule, FormlyModule],
})
export class RepeatTypeComponent extends FieldArrayType {
    constructor(
        private confirmDialogService: ConfirmationService,
        private _destroyRef: DestroyRef
    ) {
        super();
    }

    override add(index?: number): void {
        const factoryFn = this.field?.templateOptions?.rowFactory as () => any;
        const newRow = factoryFn ? factoryFn() : {};

        super.add(index, newRow);
    }

    override remove(index: number) {
        const dialog = this.confirmDialogService.open({
            title: 'deleteResultDocumentTypeTitle',
            message: 'deleteResultDocumentTypeMessage',
            icon: {
                name: 'warning',
                color: 'warn',
            },
            actions: {
                confirm: {
                    label: 'delete',
                    color: 'warn',
                },
            },
        });

        dialog
            .beforeClosed()
            .pipe(takeUntilDestroyed(this._destroyRef))
            .subscribe(result => {
                if (result === 'confirmed') {
                    super.remove(index);
                }
            });
    }
}
